import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import api from '../services/api';

// Page « mot de passe oublié ». POST /api/auth/forgot-password renvoie toujours
// 200 (pas d'énumération), on affiche donc un message générique après envoi.
const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
    } catch {
      // Réponse générique quoi qu'il arrive (aucune énumération d'emails).
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f7ff] to-[#faf8ff] flex flex-col items-center justify-center px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md text-center">
        {sent ? (
          <>
            <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-green-500 to-emerald-500 rounded-full w-16 h-16 flex items-center justify-center">
              <FaCheckCircle />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              {t('emailAuth.forgotPassword.sentTitle')}
            </h1>
            <p className="text-gray-600 mb-6">{t('emailAuth.forgotPassword.genericSuccess')}</p>
            <Link
              to="/signin"
              className="inline-block w-full py-2 text-white font-semibold rounded-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition"
            >
              {t('emailAuth.forgotPassword.backToSignin')}
            </Link>
          </>
        ) : (
          <>
            <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-purple-500 to-blue-500 rounded-full w-16 h-16 flex items-center justify-center">
              <FaEnvelope />
            </div>
            <h1 className="text-3xl font-bold text-purple-600 mb-2">
              {t('emailAuth.forgotPassword.title')}
            </h1>
            <p className="text-gray-600 mb-6">{t('emailAuth.forgotPassword.subtitle')}</p>

            <form onSubmit={handleSubmit} className="space-y-4 text-start">
              <div>
                <label className="text-sm font-medium text-gray-700">
                  {t('emailAuth.forgotPassword.email')}
                </label>
                <div className="flex items-center border rounded-md px-3 py-2 mt-1">
                  <FaEnvelope className="text-gray-400 me-2" />
                  <input
                    type="email"
                    required
                    className="w-full outline-none bg-transparent"
                    placeholder={t('emailAuth.forgotPassword.emailPlaceholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="w-full py-2 text-white font-semibold rounded-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition disabled:opacity-60"
              >
                {submitting
                  ? t('emailAuth.forgotPassword.submitting')
                  : t('emailAuth.forgotPassword.submit')}
              </button>
            </form>

            <p className="text-sm mt-6">
              <Link to="/signin" className="text-purple-600 hover:underline">
                {t('emailAuth.forgotPassword.backToSignin')}
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
